import useClassNames from '@medflex/hooks/useClassNames';
import * as PropTypes from 'prop-types';
import * as React from 'react';

const PopUpMenuArrow = ({ placement, elRef, style }) => {
  const cn = useClassNames(
    () => [
      'absolute',
      'w-6',
      'h-6',
      placement.indexOf('top') !== -1 && '-mb-3',
      placement.indexOf('top') !== -1 && 'bottom-0',
      placement.indexOf('right') !== -1 && '-ml-3',
      placement.indexOf('right') !== -1 && 'left-0',
      placement.indexOf('bottom') !== -1 && '-mt-3',
      placement.indexOf('bottom') !== -1 && 'top-0',
      placement.indexOf('left') !== -1 && '-mr-3',
      placement.indexOf('left') !== -1 && 'right-0',
    ],
    [placement],
  );
  return <div data-component="PopupMenuArrow" ref={elRef} style={style} className={cn} />;
};

PopUpMenuArrow.propTypes = {
  placement: PropTypes.string.isRequired,
  elRef: PropTypes.object,
  style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
};

export default PopUpMenuArrow;
